import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useProfileStore } from "../../store/useUserStore";
import { useNavigate } from "react-router-dom";
import { FaPassport } from "react-icons/fa";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";

const validationSchema = Yup.object().shape({
  ic: Yup.string().required("IC Number is required"),
});

const Activate = () => {
  const { t } = useTranslation();
  const { loading, setLoading, startProgress, tickProgress, submitParentActivate } = useProfileStore();
  const navigate = useNavigate();

  const handleSubmit = async (values: { ic: string }, helpers: any) => {
    const payload = {
      mode: "activate_parent",
      ic_number: values.ic,
    };

    setLoading(true);
    startProgress(1);

    try {
      const result = await submitParentActivate(payload, "activate");
      if (result.success) {
        navigate("/activate/verify");
      }
    } catch (error) {
      console.error("Activation failed:", error);
    } finally {
      setLoading(false);
      tickProgress();
      helpers.setSubmitting(false);
    }
  };

  return (
    <>
    <ProgressLoader />
    <div className="px-0 flex-grow flex flex-col">
      <Formik
        initialValues={{ ic: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, status }) => (
          <Form className="flex-grow flex flex-col">
            <div className="mb-7">
              <label className="text-sm font-medium text-black block mb-2">
                {t("activate.parent_ic")}
              </label>
              <div className="relative">
                <Field
                  type="text"
                  name="ic"
                  className="w-full text-lg text-black border-b-2 border-gray-300 focus:border-theme outline-none py-2 "
                />
                <FaPassport className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
              </div>

              <ErrorMessage
                name="ic"
                component="div"
                className="mt-1 text-red-500 text-sm"
              />
            </div>

            <div className="flex-grow"></div>

            <div className="mt-auto">
              <button
                type="submit"
                disabled={isSubmitting || loading}
                className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center mb-4"
              >
                {isSubmitting || loading
                  ? "Loading..."
                  : t("activate.activate_now")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
    </>
  );
};

export default Activate;
